module.exports = __webpack_public_path__ + "img/placeholder.4cdd9a18.png";